// 9fbef606107a605d69c0edbcd8029e5d
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { spcTitleCase } from '@tcp/core/src/utils/utils';
import {
  HEADER_LABELS,
  FACETS_FIELD_KEY,
} from '@tcp/core/src/services/abstractors/productListing/productListing.utils.js';
import colors from '@tcp/core/styles/themes/TCP/colors';
import withStyles from '../../../hoc/withStyles';
import BodyCopy from '../../BodyCopy';
import Button from '../../Button';
import style from '../styles/FilterCheckBox.style';

// returns the index (or indices) of the item(s) with the given value(s) in the given optionsMap
function getIndexOrIndicesOfValue(optionsMap, valueOrValues) {
  return Array.isArray(valueOrValues)
    ? optionsMap?.map(
        (item) => valueOrValues.findIndex((selectedValue) => item.value === selectedValue) >= 0
      )
    : optionsMap.findIndex((item) => item.value === valueOrValues);
}

// eslint-disable-next-line sonarjs/cognitive-complexity
const FilterCheckBox = (props) => {
  const {
    className,
    optionsMap,
    input,
    isLoadingMore,
    formValues,
    placeholder,
    setSelectedFilterName,
    newFilterTrackAnalytics,
    filterName,
    handleSubmitForm,
  } = props;
  const checkbox = '';
  const [limit, setLimit] = useState(true);
  const showMore = () => {
    setTimeout(() => {
      setLimit(false);
      if (newFilterTrackAnalytics) {
        newFilterTrackAnalytics({
          nav_cd171: `filter-${filterName}-show more`,
          customEvents: ['event82'],
        });
      }
    }, 0);
  };
  const showLess = () => {
    setTimeout(() => {
      setLimit(true);
      if (newFilterTrackAnalytics) {
        newFilterTrackAnalytics({
          nav_cd171: `filter-${filterName}-show less`,
          customEvents: ['event82'],
        });
      }
    }, 0);
  };

  // select the item with the given value
  const setValue = (selectedValue) => {
    const {
      allowMultipleSelections,
      input: { value, onChange, name },
    } = props;

    if (allowMultipleSelections) {
      const newValue = [...value];
      newValue.push(selectedValue);
      // notify our listeners that the user wants the value of this component to change
      onChange(newValue);
      handleSubmitForm(name, newValue);
    } else {
      // only single selection allowed
      if (value !== selectedValue) {
        // if the value to select is not the current value of this component
        // notify our listeners that the user wants the value of this component to change
        onChange(selectedValue);
        handleSubmitForm(name, selectedValue);
      }
      if (!value);
    }
  };

  const unsetValue = (value) => {
    // const { input } = props;
    const newValues = input.value.filter((val) => val !== value);
    // notify our listeners that the user wants the value of this component to change
    input.onChange(newValues);
    handleSubmitForm(input?.name, newValues);
  };

  const setItemValue = (onFilterSelection, clickedItemValue) => {
    setValue(clickedItemValue);
  };

  // handles mouse clicks on items in the dropdown
  const handleItemClick = (event, clickedItemIndex) => {
    const { allowMultipleSelections, onFilterSelection, isFavoriteView } = props;
    if (!optionsMap[clickedItemIndex]?.disabled) {
      // ignore clicks on disabled items
      const clickedItemValue = optionsMap[clickedItemIndex]?.value;
      const selectedIndex = getIndexOrIndicesOfValue(optionsMap, input?.value);
      const isFavoriteCall = isFavoriteView
        ? allowMultipleSelections && selectedIndex[clickedItemIndex] && !onFilterSelection
        : allowMultipleSelections && selectedIndex[clickedItemIndex];
      if (isFavoriteCall) {
        unsetValue(clickedItemValue); // remove clickedItemValue from this component's selcted values list
      } else {
        // set the value (or add to the value if multiple selections is on) of this component to clickedItemValue
        setItemValue(onFilterSelection, clickedItemValue);
      }
    }
  };

  const FILTER_DISPLAY_NAME_MAP = {
    gym: HEADER_LABELS.lbl_gym,
    snj: HEADER_LABELS.lbl_snj,
    tcp: HEADER_LABELS.lbl_tcp,
    pjp: HEADER_LABELS.lbl_pjp,
  };

  const itemTitleValue = (title) => {
    const hostBrand = ['tcp', 'gym', 'snj', 'pjp'];
    return hostBrand.includes(title.toLowerCase())
      ? FILTER_DISPLAY_NAME_MAP[title.toLowerCase()]
      : spcTitleCase(title);
  };

  return (
    <section className={`${className} filter-checkbox-main `}>
      {optionsMap?.length > 5 && limit ? (
        <>
          <ul className="check-list">
            {optionsMap?.slice(0, 4)?.map((item, index) => {
              const displayName =
                item?.name.toLowerCase() === FACETS_FIELD_KEY.brand ||
                item?.name.toLowerCase() === FACETS_FIELD_KEY.consolidation_brand
                  ? itemTitleValue(item?.title)
                  : item?.title;
              return (
                <li key={item} className={isLoadingMore ? 'disable-list-items' : ''}>
                  <Button
                    className="checkbox-click"
                    onClick={(e) => {
                      e.preventDefault();
                      setTimeout(() => {
                        setSelectedFilterName(placeholder);
                        handleItemClick(e, index);
                      }, 0);
                    }}
                  >
                    <div className="check-container">
                      <div
                        className={`check-box1 ${
                          formValues[optionsMap[index]?.name]?.includes(item?.value)
                            ? 'check-background check-color'
                            : ''
                        }`}
                      >
                        {checkbox}
                      </div>
                      <div
                        className={`check-label ${
                          formValues[optionsMap[index]?.name]?.includes(item?.value)
                            ? 'highlight'
                            : ''
                        }`}
                      >
                        {displayName}
                      </div>
                    </div>
                  </Button>
                </li>
              );
            })}
          </ul>
          <Button className="show-more-less" onClick={showMore}>
            <BodyCopy className="show-more-less-text" fontSize={['fs16']} fontFamily="secondary">
              <span className="limit-text">show more</span>
              <svg
                width="12"
                height="8"
                viewBox="0 0 12 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="show-more-less-icon"
              >
                <path
                  d="M11 1.44153L6 6.24658L1 1.44153"
                  stroke={colors.BUTTON.BLUE.LEFT_FILTERS_BTN}
                />
              </svg>
            </BodyCopy>
          </Button>
        </>
      ) : (
        <>
          <ul className="check-list">
            {optionsMap?.map((item, index) => {
              const displayName =
                item?.name.toLowerCase() === FACETS_FIELD_KEY.brand ||
                item?.name.toLowerCase() === FACETS_FIELD_KEY.consolidation_brand
                  ? itemTitleValue(item?.title)
                  : item?.title;
              return (
                <li key={item} className={isLoadingMore ? 'disable-list-items' : 'checkboxes'}>
                  <Button
                    className="checkbox-click"
                    type="submit"
                    onClick={(e) => {
                      e.preventDefault();
                      setTimeout(() => {
                        handleItemClick(e, index);
                        setSelectedFilterName(placeholder);
                      }, 0);
                    }}
                  >
                    <div className="check-container">
                      <div
                        className={`check-box1 ${
                          formValues[optionsMap[index]?.name]?.includes(item?.value)
                            ? 'check-background check-color'
                            : ''
                        }`}
                      >
                        {checkbox}
                      </div>
                      <div
                        className={`check-label ${
                          formValues[optionsMap[index]?.name]?.includes(item?.value)
                            ? 'highlight'
                            : ''
                        }`}
                      >
                        {displayName}
                      </div>
                    </div>
                  </Button>
                </li>
              );
            })}
          </ul>
          {optionsMap?.length > 5 ? (
            <Button className="show-more-less" onClick={showLess}>
              <BodyCopy className="show-more-less-text" fontSize={['fs16']} fontFamily="secondary">
                <span className="limit-text">show less</span>
                <svg
                  width="12"
                  height="8"
                  viewBox="0 0 12 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="show-more-less-icon"
                >
                  <path
                    d="M11 6.24646L6 1.44141L1 6.24646"
                    stroke={colors.BUTTON.BLUE.LEFT_FILTERS_BTN}
                  />
                </svg>
              </BodyCopy>
            </Button>
          ) : (
            ''
          )}
        </>
      )}
    </section>
  );
};

FilterCheckBox.propTypes = {
  className: PropTypes.string.isRequired,
  optionsMap: PropTypes.shape([]),
  input: PropTypes.shape({ value: {}, onChange: () => {} }),
  allowMultipleSelections: PropTypes.bool,
  isLoadingMore: PropTypes.bool,
  formValues: PropTypes.shape({}),
  isFavoriteView: PropTypes.bool,
  onFilterSelection: PropTypes.func,
  placeholder: PropTypes.string,
  setSelectedFilterName: PropTypes.func,
};
FilterCheckBox.defaultProps = {
  optionsMap: [],
  input: {},
  allowMultipleSelections: false,
  isLoadingMore: false,
  formValues: {},
  isFavoriteView: false,
  onFilterSelection: () => {},
  placeholder: '',
  setSelectedFilterName: () => {},
};

export default withStyles(FilterCheckBox, style);
export { FilterCheckBox as FilterCheckBoxVanilla };
